import { GOOGLE_API_KEY, TRANSLATE_ENDPOINT } from "@/constants/google";

export interface TranslateResult {
  translatedText: string;
  detectedSourceLanguage: string;
}

interface TranslateApiResponse {
  data?: {
    translations?: Array<{
      translatedText: string;
      detectedSourceLanguage?: string;
    }>;
  };
  error?: { message?: string };
}

export async function translateText(
  text: string,
  target: string,
): Promise<TranslateResult> {
  const res = await fetch(`${TRANSLATE_ENDPOINT}?key=${GOOGLE_API_KEY}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ q: text, target, format: "text" }),
  });

  const body = (await res.json().catch(() => ({}))) as TranslateApiResponse;
  if (!res.ok) {
    throw new Error(body?.error?.message || `Translate HTTP ${res.status}`);
  }

  const translation = body?.data?.translations?.[0];
  if (!translation?.translatedText) {
    throw new Error("Translate response missing translatedText");
  }

  return {
    translatedText: translation.translatedText,
    detectedSourceLanguage: translation.detectedSourceLanguage || "",
  };
}
